import React from "react";
import { Button } from "@/components/ui/button";
import { Check, ExternalLink } from "lucide-react";

export default function ConfirmationStep({ submission, onAgain, t }) {
  return (
    <div className="text-center max-w-md mx-auto py-10">
      <div className="w-16 h-16 mx-auto border-2 border-brand-primary flex items-center justify-center mb-6">
        <Check strokeWidth={1.5} className="w-8 h-8 text-brand-primary" />
      </div>
      <p className="overline" data-testid="confirm-overline">{t("confirm.confirmed")}</p>
      <h2 className="editorial-h text-4xl sm:text-5xl mt-3 text-brand-dark">{t("confirm.title")}</h2>
      <p className="font-sans text-base text-brand-muted mt-3">{t("confirm.subtitle")}</p>

      <div className="bg-white border border-brand-line p-5 mt-8 text-left">
        <p className="font-sans text-[10px] uppercase tracking-widest text-brand-muted">{t("confirm.ref")}</p>
        <p className="font-serif text-3xl text-brand-dark" data-testid="confirm-ref">#{submission.lead_ref}</p>
        <div className="border-t border-brand-line my-4" />
        <p className="font-sans text-[10px] uppercase tracking-widest text-brand-muted">{t("confirm.rep")}</p>
        <p className="font-sans text-base font-semibold text-brand-dark mt-1" data-testid="confirm-rep">{submission.rep_name}</p>
      </div>

      <a
        href={submission.wa_url}
        target="_blank"
        rel="noreferrer"
        data-testid="confirm-reopen-wa"
        className="mt-6 inline-flex items-center justify-center gap-2 w-full h-14 bg-brand-primary hover:bg-brand-primaryHover text-brand-bone font-semibold tracking-wide"
      >
        {t("confirm.reopen")} <ExternalLink strokeWidth={1.5} className="w-4 h-4" />
      </a>

      <Button
        type="button"
        variant="outline"
        onClick={onAgain}
        data-testid="confirm-again-btn"
        className="mt-3 w-full h-12 rounded-none border-brand-line text-brand-dark hover:bg-brand-primary/5"
      >
        {t("confirm.again")}
      </Button>
    </div>
  );
}
